import { StyleSheet, ViewStyle } from 'react-native'

import spacings from '@common/styles/spacings'
import flexbox from '@common/styles/utils/flexbox'

interface Styles {
  container: ViewStyle
  content: ViewStyle
  titleAndIcon: ViewStyle
  iconSquare: ViewStyle
  buttons: ViewStyle
}

const getStyles = () =>
  StyleSheet.create<Styles>({
    container: {},
    content: {
      ...spacings.phXl,
      ...spacings.ptXl,
      ...spacings.pbSm
    },
    titleAndIcon: {
      ...flexbox.alignCenter,
      ...spacings.mbXl,
      gap: 16
    },
    // Rounded icon square tinted per warning type (design-system modal convention).
    iconSquare: {
      width: 64,
      height: 64,
      borderRadius: 18,
      ...flexbox.center
    },
    // Right-aligned action row, mirroring `DialogFooter` (Cancel then confirm).
    buttons: {
      ...spacings.pbXl,
      ...spacings.phXl,
      ...flexbox.directionRow,
      ...flexbox.alignCenter,
      ...flexbox.justifyEnd,
      gap: 12
    }
  })

export default getStyles
